"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleTransporter = void 0;
var transporter_1 = require("./transporter");
var LogStore_1 = require("../LogStore");
var SimpleTransporter = /** @class */ (function (_super) {
    __extends(SimpleTransporter, _super);
    function SimpleTransporter(request) {
        var _this = _super.call(this) || this;
        _this.isPaused = false;
        _this.request = request;
        _this.pendingLogs = new LogStore_1.LogStore();
        _this.onPageHideHandler = function () { return _this.dispose(); };
        _this.onOnlineHandler = function () { return _this.resume(); };
        _this.onOfflineHandler = function () { return _this.pause(); };
        window.addEventListener("pagehide", _this.onPageHideHandler);
        window.addEventListener("online", _this.onOnlineHandler);
        window.addEventListener("offline", _this.onOfflineHandler);
        return _this;
    }
    SimpleTransporter.prototype.log = function (logData) {
        this.isPaused ? this.pendingLogs.push(logData) : this.request([logData]);
    };
    SimpleTransporter.prototype.pause = function () {
        this.isPaused = true;
    };
    SimpleTransporter.prototype.resume = function () {
        this.isPaused = false;
        this.request(this.pendingLogs.popAllLogs());
    };
    SimpleTransporter.prototype.dispose = function () {
        if (this.pendingLogs.getSize() > 0) {
            this.request(this.pendingLogs.popAllLogs());
        }
        window.removeEventListener("pagehide", this.onPageHideHandler);
        window.removeEventListener("online", this.onOnlineHandler);
        window.removeEventListener("offline", this.onOfflineHandler);
    };
    return SimpleTransporter;
}(transporter_1.Transporter));
exports.SimpleTransporter = SimpleTransporter;
//# sourceMappingURL=simpleTransporter.js.map